import React from 'react';
import SvgIcon from 'components/SvgIcon/SvgIcon';
import styles from './BriefListingCard.module.scss';

const moneyIcon = 'money';
const mapMarkerIcon = 'map_marker';
const worldGlobeIcon = 'planet_earth';
const chevronRightIcon = 'chevron-right';

const defaultIconSize = '30';
const smallIconSize = '15';

const MoneyIcon = ({ size = defaultIconSize, style = {} }) => {
  return (
    <SvgIcon
      icon={moneyIcon}
      className={styles.svgIconContainer}
      style={style}
      size={size}
    />
  );
};

const MapMarkerIcon = ({ size = defaultIconSize, style = {} }) => {
  return (
    <SvgIcon
      icon={mapMarkerIcon}
      className={styles.svgIconContainer}
      style={style}
      size={size}
    />
  );
};

const WorldGlobeIcon = ({ size = defaultIconSize, style = {} }) => {
  return (
    <SvgIcon
      icon={worldGlobeIcon}
      className={styles.svgIconContainer}
      style={style}
      size={size}
    />
  );
};

const ChevronRightIcon = ({ size = smallIconSize, style = {} }) => {
  return (
    <SvgIcon
      icon={chevronRightIcon}
      className={styles.svgIconContainer}
      style={style}
      size={size}
    />
  );
};

export { MoneyIcon, MapMarkerIcon, WorldGlobeIcon, ChevronRightIcon };
